import { useMutation } from '@tanstack/react-query';

import { PluginRemoveRelation } from '../../../../types/plugins';
import { handleError, handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { runRemoveRelation } from '../../requests/runRemoveRelation';

export const useRunRemoveRelation = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: PluginRemoveRelation) =>
      runRemoveRelation(constructPost, data),
    onSuccess: () => handleSuccess('Guarantor removed successfully'),
    onError: () => handleError('Guarantor was not removed'),
  });
  return { runRemoveRelation: mutateAsync, ...rest };
};
